class ProjectTeaser {
	constructor($el) {
		this.$el = $el;
		this.$items = $('.table__item');
		this.$teaser = this.$el.find('.table__teaser');
		this.$teasers = $('.table__teaser');
		this.position = null;

		this.init();
	}

	init = () => {
		this.$el.on('mousemove', this.onMove);
		this.$el.on('mouseenter', this.onEnter);
		this.$el.on('mouseleave', this.onLeave);
	};

	onMove = (e) => {
		const offset = this.$el.offset();
		const x = e.pageX - offset.left;

		this.$teaser.add(this.$teasers).css({
			transform: `translateX(${x}px)`
		});


	};

	onEnter = () => {
		this.$items.css("z-index", "-5");
		this.$el.css("z-index", "0");

	}

	onLeave = () => {
		this.$items.css("z-index", "0");

	}
}

export default ProjectTeaser;